export const transformFiles = (data = []) => {
  if (!Array.isArray(data)) return [];
  return data.flatMap((entry) => {
    // Handle 'attachments' array of strings (OtherPayment format)
    if (Array.isArray(entry.attachments) && entry.attachments.length > 0) {
      return entry.attachments.map((path) => {
        const parts = path.split("/");
        const fileName = parts[parts.length - 1];
        return {
          name: fileName,
          filePath: path,
          uploadedOn: entry.addedOn || entry.updatedAt, // Fallback date
        };
      });
    }

    // Handle existing 'file' nested structure
    if (!Array.isArray(entry.file)) return [];

    return entry.file.flatMap((fileItem) => {
      if (!Array.isArray(fileItem.keys)) return [];

      return fileItem.keys.map((key) => ({
        name: fileItem.name,
        comments: fileItem.comments,
        _id: fileItem?._id,
        uploadedOn: fileItem.uploadedOn,
        ...(fileItem.keys.length === 1 ? { filePath: key } : { filePath: key }),
      }));
    });
  });
};
